import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { FaPlus, FaMinus } from "react-icons/fa";
import Select from "react-select";
import { Form, Row, Col, Modal, Button } from "react-bootstrap";
import { Languages } from "../../../../constants/articleApp";
import "../../../../assets/css/cms/Products.css";
import { Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  getWebStoryAddEdit,
  getWebStoryFilterWebstoryTitle,
  getWebStoryFilterEntityType,
  getWebStoryFilterEntityName,
  putWebStoryAddEdit,
  getEntityFilter,
  deleteEntityFilter,
  postEntityFilter,
  getWebStoryFilter,
} from "../../../../../store/actions/cms/webStory";
import "./webstory.css";
import { PAGEAVAILABILITY } from "../../../../constants/cms";

function EditWebStories() {
  const [debounceState, setDebounceState] = useState("");
  const { id } = useParams();
  const [title, setTitle] = useState(null);
  const [language, setLanguage] = useState(null);
  const dispatch = useDispatch();
  const [entityType, setEntityType] = useState(null);
  const [pageAvailabilityCheck, setPageAvailabilityCheck] = useState([]);
  const [isPublished, setIsPublished] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [primaryEntities, setPrimaryEntities] = useState({});
  const [hasUserEdited, setHasUserEdited] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [entityPrimaryMap, setEntityPrimaryMap] = useState({});
  const [filterModalMap, setFilterModalMap] = useState({});
  const [titleError, setTitleError] = useState("");
  const [languageError, setLanguageError] = useState("");
  const navigate = useNavigate();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [activeMapping, setActiveMapping] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const { user } = useSelector((state) => state.userData);
  const [entityModalError, setEntityModalError] = useState("");
  const {
    webStoryAddEditData,
    webStoryFilterWebstoryTitleData,
    webStoryFilterEntityTypeData,
    webStoryFilterEntityNameData,
    webStoryFilterData,
    getEntityFilterData,
  } = useSelector((state) => state.webStoryReducer);

  const { userPermission } = useSelector((state) => {
    return state.userData;
  });
  const [nextId, setNextId] = useState(2); // Start from 2 since the initial row has id 1

  // check permission to publish/unpublish webstory
  const findPermission = (application, action) => {
    let authorized = false;
    const userPermissions = userPermission?.data;
    if (userPermissions) {
      authorized = userPermissions.some((permission) => {
        return (
          permission.content_type === application && permission.name === action
        );
      });
    }
    return authorized;
  };

  // Dynamic fields state
  const [entityMappings, setEntityMappings] = useState([
    {
      id: 1,
      title: null,
      language: null,
      entity_name: null,
      entity_type: null,
    },
  ]);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // css constant for primary and non-primary logic
  const getMultiValueStyles = () => ({
    multiValue: (base, state) => {
      const isPrimary = state.data.isPrimary === 1;
      return {
        ...base,
        backgroundColor: isPrimary ? "#32CD32" : "#e2e3e5",
        borderRadius: "2px",
        padding: "2px 6px",
      };
    },
    multiValueLabel: (base, state) => {
      const isPrimary = state.data.isPrimary === 1;
      return {
        ...base,
        color: "#000",
        fontWeight: isPrimary ? "bold" : "normal",
      };
    },
  });

  // language options- English or Hindi
  const languageOptions = Languages?.map((item) => ({
    value: item.id,
    label: item.label,
  }));

  // Updated handleAddRow function
  const handleAddRow = () => {
    setEntityMappings([
      ...entityMappings,
      {
        id: nextId,
        title: null,
        language: null,
        entity_name: [],
        entity_type: null,
      },
    ]);

    setNextId(nextId + 1); // Increment the next ID
  };

  // Updated handleRemoveRow function
  const handleRemoveRow = (id) => {
    setEntityMappings(entityMappings.filter((item) => item.id !== id));
  };
  const renderAddButton = (onClick) => {
    const isAddButtonDisabled = entityMappings.some(
      (mapping) => !mapping.entity_name || mapping.entity_name.length === 0
    );
    return (
      <button
        type="button"
        className={`btn btn-outline-success ${
          isAddButtonDisabled && "disabled_plus"
        }`}
        onClick={onClick}
        title="Add another row"
        disabled={isAddButtonDisabled}
      >
        <FaPlus />
      </button>
    );
  };

  const renderRemoveButton = (mapping) => (
    <button
      type="button"
      className="btn btn-outline-danger"
      onClick={() => {
        dispatch(
          deleteEntityFilter({
            webstory_id: id || title?.id,
            entity_type: mapping?.entity_type?.entity_type,
          })
        );
        setEntityMappings((prev) => prev.filter((m) => m.id !== mapping.id));
      }}
      title="Remove this row"
    >
      <FaMinus />
    </button>
  );

  const isPrimaryButtonEnabled = entityMappings.some(
    (mapping) => mapping.entity_name && mapping.entity_name.length > 0
  );

  // on change function for input fields
  const handleChange = (index, field, option) => {
    const newEntityMappings = [...entityMappings];
    const prevMapping = newEntityMappings[index];
    const mapping = { ...prevMapping };

    if (field === "entity_type") {
      if (!option) {
        mapping.entity_type = null;
        mapping.entity_name = [];

        setPrimaryEntities((prev) => ({ ...prev, [mapping.id]: null }));
        setEntityPrimaryMap((prev) => ({ ...prev, [mapping.id]: [] }));

        newEntityMappings[index] = mapping;
        setEntityMappings(newEntityMappings);
        setHasUserEdited(true);
        return;
      }

      setEntityType(option);

      if (option.entity_type) {
        dispatch(
          getWebStoryFilterEntityName({
            filter_type: "mappable_entities",
            entity_type: option.entity_type,
          })
        );
      }

      mapping.entity_type = option;
      mapping.entity_name = [];

      setPrimaryEntities((prev) => ({ ...prev, [mapping.id]: null }));
      setEntityPrimaryMap((prev) => ({ ...prev, [mapping.id]: [] }));
    } else if (field === "entity_name") {
      const prevEntityName = Array.isArray(prevMapping.entity_name)
        ? [...prevMapping.entity_name]
        : [];

      if (!option || option.length === 0) {
        mapping.entity_name = [];
        setPrimaryEntities((prev) => ({ ...prev, [mapping.id]: null }));
        setEntityPrimaryMap((prev) => ({ ...prev, [mapping.id]: [] }));
      } else {
        const updatedOption = option?.map((item, idx) => {
          const existingItem = prevEntityName?.find(
            (e) => (e.value || e.entity_id) === (item.value || item.entity_id)
          );

          return {
            ...item,
            entity_id: item.entity_id || existingItem?.entity_id || null,
            keyword_id:
              item.keyword_id || existingItem?.keyword_id || item.value || null,
            webstory_mapping_id: existingItem?.webstory_mapping_id || null,
            isPrimary: id
              ? existingItem?.isPrimary === 1
                ? 1
                : idx === 0
                ? 1
                : 0
              : idx === 0
              ? 1
              : 0, // ADD MODE ONLY
          };
        });

        mapping.entity_name = updatedOption;
        setEntityPrimaryMap((prev) => ({
          ...prev,
          [mapping.id]: updatedOption?.map((ent) => ({
            entity_name: ent.entity_name || ent.label,
            is_primary: ent.isPrimary,
          })),
        }));
      }
    }

    newEntityMappings[index] = mapping;
    setEntityMappings(newEntityMappings);
    setHasUserEdited(true);
  };
  const handleOpenFilterModal = (mapping) => {
    const entityIds = mapping?.entity_name
      ?.map((e) => e.entity_id)
      .filter(Boolean);

    const params = {
      webstory_id: id || title?.id,
      entity_type: mapping?.entity_type?.entity_type,
      entity_id: entityIds?.join(","),
    };
    const nameParams = {
      filter_type: "filter_name",
      entity_type: mapping?.entity_type?.entity_type,
    };

    if (id) {
      dispatch(getEntityFilter(params));
      dispatch(getWebStoryFilter(nameParams));
    } else {
      dispatch(getWebStoryFilter(nameParams));
    }

    setActiveMapping(mapping);
    setSelectedFilters(mapping.filters || []);
    setShowFilterModal(true);
  };

  useEffect(() => {
    if (!id || !getEntityFilterData?.filter_map_data?.length) return;

    const mappedFilters = {};

    getEntityFilterData.filter_map_data.forEach((item) => {
      const keyData = item?.filter_key_data || [];

      keyData.forEach((filterItem) => {
        const entityId = filterItem.entity_id;

        const filterObj = {
          value: filterItem.filter_name,
          filter_id: filterItem.filter_id,
          label: filterItem.filter_name,
        };

        if (filterItem.webstory_filter_id) {
          filterObj.webstory_filter_id = filterItem.webstory_filter_id;
        }

        if (!mappedFilters[entityId]) mappedFilters[entityId] = [];
        mappedFilters[entityId].push(filterObj);
      });
    });

    setSelectedFilters(mappedFilters);
  }, [getEntityFilterData, webStoryFilterData, id]);

  const handleCloseFilterModal = () => {
    setShowFilterModal(false);
    setActiveMapping(null);
    setSelectedFilters([]);
  };

  //add filter modal save function
  const handleFilterModalSave = () => {
    if (!activeMapping) return;

    const webstoryId = id || title?.id;

    
  if (!webstoryId) {
    setShowFilterModal(false);
    setActiveMapping(null);
    setSelectedFilters([]);
    setTimeout(() => {
      setAlertType("error");
      setAlertMessage("Please select a Web Story before adding filters.");
      setShowAlert(true);
    }, 0);
    return;
  }
    const updatedEntityMappings = entityMappings.map((m) => {
      if (m.id !== activeMapping.id) return m;
      return {
        ...m,
        filters: selectedFilters,
      };
    });

    setEntityMappings(updatedEntityMappings);
    setShowFilterModal(false);

    const entityType =
      activeMapping?.entity_type?.entity_type ||
      activeMapping?.entity_type?.label;

    const filter_map_data = (activeMapping?.entity_name || [])
      .map((entity) => {
        const entityId = entity?.value || entity?.entity_id;
        const label = entity?.label || entity?.entity_name;
        const filters = selectedFilters?.[entityId] || [];

        if (!filters.length) return null;

        return {
          filter_key_name: `${entityType} - ${label}`,
          filter_key_data: filters.map((filter) => ({
            filter_id: filter?.filter_id || filter?.value,
            entity_id: entityId,
            webstory_filter_id: filter?.webstory_filter_id ?? null,
          })),
        };
      })
      .filter(Boolean);
      
    const filterOptions = {
      webstory_id: id || title?.id,
      entity_type: entityType,
      filter_map_data,
    };

    setFilterModalMap(filterOptions);
  };


  useEffect(() => {
    if (webStoryAddEditData) {
      setIsPublished(webStoryAddEditData?.status);
      dispatch(
        getWebStoryFilterEntityName({
          filter_type: "mappable_entities",
          entity_type:
            webStoryAddEditData?.webstory_keyword_entity?.[0]?.entity_type,
        })
      );
    }
    if (webStoryAddEditData?.title) {
      let params = {};
      params.filter_type = "webstory_title";
      params.term = webStoryAddEditData?.title;
      dispatch(getWebStoryFilterWebstoryTitle(params));
    }
  }, [webStoryAddEditData]);

  useEffect(() => {
    if (id && webStoryAddEditData?.webstory_keyword_entity?.[0]?.entity_type) {
      const initialEntityType =
        webStoryFilterEntityTypeData?.mappable_entity_types?.find(
          (type) =>
            type.entity_type ===
            webStoryAddEditData.webstory_keyword_entity[0].entity_type
        );

      if (initialEntityType && !entityType) {
        setEntityType(initialEntityType);
      }
    }
  }, [id, webStoryAddEditData, webStoryFilterEntityTypeData]);

  useEffect(() => {
    const newPrimaryEntities = {};
    entityMappings.forEach((mapping) => {
      if (Array.isArray(mapping.entity_name)) {
        const rowId = mapping.id;
        const currentPrimary = primaryEntities[rowId];
        const primaryStillExists = mapping.entity_name.some(
          (e) => e.value === currentPrimary
        );
        newPrimaryEntities[rowId] = primaryStillExists
          ? currentPrimary
          : mapping.entity_name[0]?.value;
      }
    });
    setPrimaryEntities(newPrimaryEntities);
  }, [entityMappings]);

  useEffect(() => {
    dispatch(
      getWebStoryFilterEntityType({ filter_type: "mappable_entity_types" })
    );
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(getWebStoryAddEdit({ webstory_id: id }));
    }
  }, [id]);

  const handleInputChange = (filter_type, value, entity_type = null) => {
    let params = {};
    params.filter_type = filter_type;
    params.term = value;
    let inDebounce = debounceState;
    if (filter_type === "webstory_title") {
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        dispatch(getWebStoryFilterWebstoryTitle(params));
      }, 1000);
      setDebounceState(inDebounce);
    }
    if (filter_type === "unmapped_webstory_title") {
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        dispatch(getWebStoryFilterWebstoryTitle(params));
      }, 1000);
      setDebounceState(inDebounce);
    }
    if (filter_type === "mappable_entities") {
      params.entity_type = (entity_type) ? entity_type : entityType.entity_type;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        if(value?.length>0) dispatch(getWebStoryFilterEntityName(params));
      }, 1000);
      setDebounceState(inDebounce);
    }
  };

  useEffect(() => {
    if (
      id &&
      webStoryAddEditData?.title &&
      webStoryFilterWebstoryTitleData?.story_titles?.length
    ) {
      const matchedTitle = webStoryFilterWebstoryTitleData.story_titles?.find(
        (option) => option.title === webStoryAddEditData.title
      );
      setTitle(matchedTitle || null);
    }
  }, [
    id,
    webStoryAddEditData?.title,
    webStoryFilterWebstoryTitleData?.story_titles,
  ]);

  useEffect(() => {
    if (
      id &&
      webStoryAddEditData?.webstory_keyword_entity?.length > 0 &&
      webStoryFilterEntityNameData?.entity_names &&
      !hasUserEdited
    ) {
      const prefillMappings = webStoryAddEditData.webstory_keyword_entity?.map(
        (entity, index) => {
          const matchedEntityType =
            webStoryFilterEntityTypeData?.mappable_entity_types?.find(
              (option) => option.entity_type === entity.entity_type
            );
          setEntityType(matchedEntityType);
          const matchedEntityNames = entity.entity_data?.map((i) => {
            const found = webStoryFilterEntityNameData.entity_names?.find(
              (e) => e.keyword_id === i.keyword_id
            ) || {
              label: i.entity_name,
              value: i.keyword_id,
              entity_name: i.entity_name,
              keyword_id: i.keywords_id,
              entity_id: i.entity_id,
            };
            return {
              ...found,
              isPrimary: i.is_primary === 1 ? 1 : 0,
              webstory_mapping_id: i.webstory_mapping_id || null,
            };
          });

          return {
            id: index + 1,
            entity_type: matchedEntityType || {
              label: entity.entity_type,
              value: entity.entity_type,
            },
            entity_name: matchedEntityNames,
          };
        }
      );

      setEntityMappings(prefillMappings);
      const maxId = Math.max(...prefillMappings.map((m) => m.id || 0));
      setNextId(maxId + 1);

      const initialPrimaryEntities = {};
      const initialEntityPrimaryMap = {};

      prefillMappings.forEach((mapping) => {
        const primaryItem = mapping.entity_name?.find((e) => e.isPrimary);
        initialPrimaryEntities[mapping.id] = primaryItem?.value || null;

        initialEntityPrimaryMap[mapping.id] =
          mapping.entity_name?.map((e) => ({
            entity_name: e.entity_name,
            is_primary: e.isPrimary ? 1 : 0,
          })) || [];
      });

      setPrimaryEntities(initialPrimaryEntities);
      setEntityPrimaryMap(initialEntityPrimaryMap);
    }
  }, [
    id,
    webStoryAddEditData,
    webStoryFilterEntityTypeData,
    webStoryFilterEntityNameData,
    hasUserEdited,
  ]);

  useEffect(() => {
    if (id && entityMappings.length > 0) {
      const initialPrimary = {};
      entityMappings.forEach((mapping) => {
        const primary = mapping.entity_name?.[0];
        if (primary) {
          initialPrimary[mapping.id] = primary.value;
        }
      });
      setPrimaryEntities(initialPrimary);
    }
  }, [id, entityMappings]);

  const handlePageTypeChange = (index) => {
    setPageAvailabilityCheck((prev) =>
      prev?.map((item, i) =>
        i === index ? { ...item, show_on_page: !item.show_on_page } : item
      )
    );
  };

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => setShowAlert(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showAlert]);

  useEffect(() => {
    if (id && webStoryAddEditData?.webstory_page_availability) {
      setPageAvailabilityCheck(webStoryAddEditData?.webstory_page_availability);
    } else {
      setPageAvailabilityCheck(PAGEAVAILABILITY);
    }
  }, [id, webStoryAddEditData]);

  useEffect(() => {
    if (
      !language &&
      webStoryAddEditData?.language_name &&
      languageOptions?.length > 0
    ) {
      const matchedLanguage = languageOptions?.find(
        (option) => option.label === webStoryAddEditData.language_name
      );
      if (matchedLanguage) {
        setLanguage(matchedLanguage);
      }
    }
  }, [webStoryAddEditData, languageOptions]);

  //save functionality of the page 
  const handleSave = () => {
    let hasError = false;
    setTitleError("");
    setLanguageError("");
    setShowAlert(false);

    // Validate at least one page type is selected
    const allPageTypesUnchecked = pageAvailabilityCheck.every(
      (item) => !item.show_on_page
    );
    if (allPageTypesUnchecked) {
      setAlertType("error");
      setAlertMessage("Please select at least one page type to proceed");
      setShowAlert(true);
      return;
    }

    // Validate that each mapping has at least one primary
    const missingPrimary = entityMappings.some((mapping) => {
      const relevant = entityPrimaryMap?.[mapping.id] || [];
      return (
        mapping.entity_name?.length > 0 &&
        !relevant.some((e) => e.is_primary === 1)
      );
    });

    // Title and Language validations
    if (!title) {
      setTitleError("Please select the Web Story before proceeding");
      hasError = true;
    }

    if (!language) {
      setLanguageError("Please select Language of Web Story");
      hasError = true;
    }

    if (hasError) return;

    // Group entities by entity_type
    const groupedEntities = {};

    entityMappings.forEach((mapping) => {
      if (!mapping.entity_type || !mapping.entity_name?.length) return;

      const entityType =
        typeof mapping.entity_type === "object"
          ? mapping.entity_type.entity_type
          : mapping.entity_type;

      if (!groupedEntities[entityType]) {
        groupedEntities[entityType] = [];
      }

      mapping.entity_name.forEach((entity) => {
        const isPrimaryEntry = entityPrimaryMap?.[mapping.id]?.find(
          (item) => item.entity_name === (entity.entity_name || entity.label)
        );

        const isPrimary = isPrimaryEntry?.is_primary === 1 ? 1 : 0;

        groupedEntities[entityType].push({
          entity_type: entityType,
          entity_id: entity.entity_id || entity.value || 1,
          keywords_id: entity.keyword_id || entity.value || null,
          webstory_mapping_id: entity.webstory_mapping_id || null,
          is_primary: isPrimary,
          webstory_id: id ? id : title?.id,
          entity_name: entity.entity_name || entity.label,
        });
      });
    });

    const payload = {
      id: id ? id : title?.id,
      language_id: language?.value,
      status: isPublished,
      updated_by: user?.data?.id || 1,
      webstory_page_availability: pageAvailabilityCheck,
      webstory_keyword_entity: Object.entries(groupedEntities)?.map(
        ([entity_type, entity_data]) => ({
          entity_type,
          entity_data,
        })
      ),
    };

    dispatch(putWebStoryAddEdit({ id, data: payload }))
      .then((res) => {
        const status = res?.status;

        if (status === 200) {
          setAlertType("success");
          setAlertMessage("Changes saved successfully.");
          setShowAlert(true);

          setTimeout(() => {
            navigate("/cms/content/web-stories");
          }, 1500);
        } else {
          setAlertType("error");
          setAlertMessage("Failed to save changes. Please try again.");
          setShowAlert(true);
        }
      })
      .catch((err) => {
        let alertMessage = JSON.stringify(err?.response?.data?.message);
        setAlertType("error");
        setAlertMessage(alertMessage);
        setShowAlert(true);
      });

      dispatch(postEntityFilter(filterModalMap))
      .then((res) => {
        setAlertType("success");
        setAlertMessage("Filters saved successfully.");
        setShowAlert(true);
      })
      .catch((err) => {
        setAlertType("error");
        setAlertMessage("Failed to save filters. Please try again.");
        setShowAlert(true);
      });
  };

  const handleModalSave = () => {
    const hasAnyPrimary = Object.values(entityPrimaryMap).some((entityArray) =>
      entityArray?.some((e) => e.is_primary === 1)
    );

    if (!hasAnyPrimary) {
      setEntityModalError("Please select at least one primary entity.");
      return;
    }

    // Clear error if validation passes
    setEntityModalError("");
    handleCloseModal();
  };

  return (
    <>
      {showAlert && (
        <div className="notification_popup">
          <Alert severity={alertType}>{alertMessage}</Alert>
        </div>
      )}
      <h1
        className="news_letter_heading mx-0 mt-5"
        style={{ fontSize: "1.5rem" }}
      >
        Add/Edit WebStories Mapping
      </h1>

      {/* ------------breadcrumb------------------- */}
      <div>
        <ul className={"sub_nav_ul"}>
          <li className={"sub_nav_list"}>
            <Link to="/cms/">
              <span className={"sub_nan_anchor"}>Home</span>
            </Link>
          </li>
          <li className={"sub_nav_list"}>
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li className={"sub_nav_list"}>
            <Link to="/cms/content/web-stories">
              <span className={"sub_nan_anchor"}>Manage Web Stories</span>
            </Link>
          </li>
          <li className={"sub_nav_list"}>
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li className={"sub_nav_list sub_nav_list_active"}>Add/Edit</li>
        </ul>
      </div>

      {/* ------------Web Story Filters------------------- */}
      <div className="select_story">
        <div className="heading">Select WebStory</div>
        <div>
          <Form>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group>
                  <Select
                    name="webstory_title"
                    placeholder="Search and Select webstory title * "
                    value={title}
                    onChange={(option) => {
                      setTitle(option);
                      if (option) setTitleError("");
                    }}
                    onInputChange={(val) => {
                      if (val.length >= 0) {
                        const field = id
                          ? "webstory_title"
                          : "unmapped_webstory_title";
                        handleInputChange(field, val);
                      }
                    }}
                    getOptionLabel={(option) => option?.title}
                    getOptionValue={(option) => option?.id}
                    options={
                      webStoryFilterWebstoryTitleData?.story_titles || []
                    }
                    isClearable={true}
                    isDisabled={id}
                  />
                  {titleError && (
                    <div className="text-danger mt-1">{titleError}</div>
                  )}
                </Form.Group>
              </Col>

              <Col md={4} className="mb-3">
                <Form.Group>
                  <Select
                    name="language"
                    placeholder="Select language * "
                    value={language}
                    onChange={(option) => {
                      setLanguage(option);
                      if (option) setLanguageError("");
                    }}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    options={languageOptions}
                    isClearable={true}
                    isDisabled={id}
                  />
                  {languageError && (
                    <div className="text-danger mt-1">{languageError}</div>
                  )}
                </Form.Group>
              </Col>

              <Col md={4} className="Publish_check">
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    className="add_edit_check publish-label"
                    label="Publish WebStory"
                    checked={isPublished === 1}
                    onChange={(e) => {
                      // checking user have the appropriate access to unpublish webstory mapping
                      if (
                        !e.target.checked &&
                        !findPermission(
                          "webstory",
                          "Unpublish Webstory Mapping"
                        )
                      ) {
                        setAlertType("error");
                        setAlertMessage(
                          "You do not have access to unpublish this WebStory."
                        );
                        setShowAlert(true);
                        return;
                      }
                      setIsPublished(e.target.checked ? 1 : 0);
                    }}
                    id="publish-webstory"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      {/* ------------Entity/Keyword Mapping------------------- */}
      <div className="select_story">
        <div className="heading_div">
          <div className="heading">Entity/Keyword Mapping</div>
          <div className="primary_entity">
            <button
              className={`exam_button rounded-pill ${
                !isPrimaryButtonEnabled ? "disabled-button" : ""
              }`}
              onClick={handleOpenModal}
              isDisabled={!isPrimaryButtonEnabled}
            >
              Mark Primary Entity
            </button>
          </div>
        </div>
        <Form>
          {entityMappings?.map((mapping, index) => (
            <Row key={mapping.id} className="align-items-end mb-2">
              <Col md={3} className="mb-3">
                <Select
                  placeholder="Select entity type"
                  value={mapping.entity_type || null}
                  onChange={(option) =>
                    handleChange(index, "entity_type", option)
                  }
                  options={(
                    webStoryFilterEntityTypeData?.mappable_entity_types || []
                  ).filter(
                    (option) =>
                      option.entity_type === mapping.entity_type?.entity_type ||
                      !entityMappings.some(
                        (m, i) =>
                          i !== index &&
                          m.entity_type?.entity_type === option.entity_type
                      )
                  )}
                  getOptionLabel={(option) => option?.entity_type}
                  getOptionValue={(option) => option?.entity_type}
                  isClearable={true}
                  isSearchable={true}
                />
              </Col>
              <Col md={4} className="mb-3">
                <Select
                  placeholder="Search and Select entity name"
                  value={mapping.entity_name || []}
                  onInputChange={(val) =>
                    handleInputChange("mappable_entities", val, entityMappings[index]?.entity_type?.entity_type)
                  }
                  onChange={(newValue, actionMeta) => {
                    handleChange(index, "entity_name", newValue);
                    if (
                      actionMeta.action === "remove-value" ||
                      actionMeta.action === "pop-value"
                    ) {
                      const removedOption = actionMeta.removedValue;
                  
                      dispatch(
                        deleteEntityFilter({
                          webstory_id: id || title?.id,
                          entity_type: mapping?.entity_type?.entity_type,
                          entity_id:
                            removedOption?.entity_id || removedOption?.value,
                        })
                      );
                      setSelectedFilters((prev) => {
                        const updated = { ...prev };
                        delete updated[
                          removedOption?.entity_id || removedOption?.value
                        ];
                        return updated;
                      });
                    }
                  }}                  
                  options={webStoryFilterEntityNameData?.entity_names || []}
                  getOptionLabel={(option) => option?.entity_name}
                  getOptionValue={(option) => option?.keyword_id}
                  isMulti
                  isClearable={false}
                  closeMenuOnSelect={false}
                  multiple={true}
                  styles={getMultiValueStyles(mapping)}
                  isDisabled={!mapping.entity_type}
                  onFocus={()=>{
                   dispatch(getWebStoryFilterEntityName({ entity_type: entityMappings[index]?.entity_type?.entity_type, filter_type: "mappable_entities" }))
                  }}
                  filterOption={() => true}
                />
              </Col>
              <Col md={1} style={{ width: "120px" }}>
                <button
                  type="button"
                  className={`exam_button rounded-pill ${
                    !mapping.entity_name || mapping.entity_name.length === 0
                      ? "disabled-button"
                      : ""
                  }`}
                  onClick={() => handleOpenFilterModal(mapping)}
                  style={{
                    marginBottom: "15px",
                    width: "max-content",
                    height: "35px",
                  }}
                  disabled={
                    !mapping.entity_name || mapping.entity_name.length === 0
                  }
                >
                  Add Filter
                </button>
              </Col>

              <Col md={2} className="mb-3 d-flex gap-2">
                {index === entityMappings.length - 1 &&
                  renderAddButton(handleAddRow)}
                {entityMappings.length > 1 && renderRemoveButton(mapping)}
              </Col>
            </Row>
          ))}
        </Form>
      </div>

      {/* page type checkbox block */}
      <div className="select_story">
        <div className="heading_div">
          <div className="heading">Page Type Mapping</div>
        </div>
        <Form>
          <div className="page_type">
            {pageAvailabilityCheck?.map((item, index) => {
              const checkboxId = `page_type_${index}`;
              return (
                <div key={index} className="form-check mb-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={checkboxId}
                    checked={item.show_on_page}
                    onChange={() => handlePageTypeChange(index)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={checkboxId}
                    style={{ cursor: "pointer" }}
                  >
                    {item.page_type}
                  </label>
                </div>
              );
            })}
          </div>
        </Form>
      </div>
      <div className="manage_web-story">
        <button className="exam_button" onClick={handleSave}>
          Save
        </button>
      </div>

      {/* Modal for marking primary entity */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Mark Primary Entity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {entityModalError && (
            <div className="alert alert-danger p-2 mb-3" role="alert">
              {entityModalError}
            </div>
          )}
          {entityMappings
            .filter((mapping) => mapping.entity_name?.length > 0)
            .map((mapping, mappingIndex, filteredArray) => (
              <div key={mapping.id || `row-${mappingIndex}`} className="mb-3">
                {mapping.entity_name.map((entity, idx) => {
                  const checkboxId = `mapping-${mappingIndex}-entity-${idx}`;

                  return (
                    <div key={checkboxId} className="form-check mb-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={checkboxId}
                        checked={entity.isPrimary === 1}
                        onChange={(e) => {
                          const isChecked = e.target.checked;

                          if (isChecked) setEntityModalError("");
                          setEntityMappings((prevMappings) =>
                            prevMappings.map((m) => {
                              if (m.id !== mapping.id) return m;
                              return {
                                ...m,
                                entity_name: m.entity_name.map((ent) => {
                                  const isSameEntity =
                                    (ent.value || ent.entity_id) ===
                                      (entity.value || entity.entity_id) &&
                                    (ent.entity_name || ent.label) ===
                                      (entity.entity_name || entity.label);
                                  return {
                                    ...ent,
                                    isPrimary: isSameEntity
                                      ? isChecked
                                        ? 1
                                        : 0
                                      : ent.isPrimary,
                                  };
                                }),
                              };
                            })
                          );

                          setEntityPrimaryMap((prevMap) => {
                            const updatedMap = [
                              ...(entityMappings[mappingIndex]?.entity_name ||
                                []),
                            ].map((ent) => {
                              const isSameEntity =
                                (ent.value || ent.entity_id) ===
                                  (entity.value || entity.entity_id) &&
                                (ent.entity_name || ent.label) ===
                                  (entity.entity_name || entity.label);

                              return {
                                entity_name: ent.entity_name || ent.label,
                                is_primary: isSameEntity
                                  ? isChecked
                                    ? 1
                                    : 0
                                  : ent.isPrimary
                                  ? 1
                                  : 0,
                              };
                            });

                            return {
                              ...prevMap,
                              [mapping.id || `row-${mappingIndex}`]: updatedMap,
                            };
                          });
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={checkboxId}
                        style={{ cursor: "pointer" }}
                      >
                        {`${
                          mapping.entity_type?.entity_type ||
                          mapping.entity_type?.label ||
                          "Entity Type"
                        } - ${
                          entity.label ||
                          entity.value ||
                          entity.entity_name ||
                          "Unnamed Entity"
                        }`}
                      </label>
                    </div>
                  );
                })}
                {mappingIndex < filteredArray.length - 1 && <hr />}
              </div>
            ))}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleModalSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} onHide={handleCloseFilterModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Filters</Modal.Title>
        </Modal.Header>
        <div
          style={{
            fontSize: "0.85rem",
            fontWeight: "normal",
            marginTop: "4px",
            color: "#6c757d",
            padding: "0px 10px",
          }}
        >
          NOTE: Add filters against each keyword in order to target them to
          specific pages. This is non mandatory. In case filters are not added
          only the keyword will be considered in display logic
        </div>
        <Modal.Body>
          {(activeMapping?.entity_name || []).map((entity, idx) => {
            const entityKey =
              entity.entity_id || entity.value || `entity-${idx}`;
            const label = entity.entity_name || entity.label;
            const fullLabel = `${
              activeMapping?.entity_type?.entity_type ||
              activeMapping?.entity_type?.label
            } - ${label}`;

            const currentValue = selectedFilters[entityKey] || [];

            return (
              <div key={entityKey} className="mb-3">
                <div className="mb-2 fw-semibold">{fullLabel}</div>
                <Select
                  placeholder="Select filters"
                  isMulti
                  isClearable={false}
                  isSearchable={true}
                  value={currentValue}
                  onChange={(selected) =>
                    setSelectedFilters((prev) => ({
                      ...prev,
                      [entityKey]: selected,
                    }))
                  }
                  options={webStoryFilterData?.filter_names?.map((item) => {
                    return {
                      label: item.filter_name,
                      value: item.filter_id,
                    };
                  })}
                  getOptionLabel={(opt) => opt.label}
                  getOptionValue={(opt) => opt.value}
                />
              </div>
            );
          })}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleFilterModalSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditWebStories;
